<template>
  <button @click="onlineService">在线客服</button>
</template>

<script>
let flag = false
export default {
  name: 'onlineService',
  methods: {
    onlineService () {
      if (flag) {
        return
      }
      flag = true
      location.href = process.env.VUE_APP_ONLINE_SERVICE
      flag = false
    }
  }
}
</script>

<style lang="less" scoped>
button {
  width: 2.2rem;
  height: 0.68rem;
  border: 0.5px solid #3498DB;
  border-radius: 30px;
  font-size: @fz24;
  color: #4A90E2;
}
</style>
